import { Pipe } from '@angular/core';
import { isArray } from '../utils/utils';
var LastPipe = (function () {
    function LastPipe() {
    }
    LastPipe.prototype.transform = function (input) {
        if (!isArray(input)) {
            return input;
        }
        // Returns undefined if empty
        return input[input.length - 1];
    };
    return LastPipe;
}());
export { LastPipe };
LastPipe.decorators = [
    { type: Pipe, args: [{
                name: 'last'
            },] },
];
/** @nocollapse */
LastPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=last.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/array/last.pipe.js
// module id = 240
// module chunks = 103